export default "__VITE_ASSET__DcloL2sh__"